import {
  Section,
  Skeleton,
  SkeletonCardButtonSmallRounded,
} from '@ferreri/prever-component-lib';

import { StyledGroupElementScroll } from '../../modules/home/StyledGroupElementScroll';

export const SkeletonProductSection = () => {
  const cardsArray = Array.from({ length: 4 });

  return (
    <Section>
      <Skeleton width="100%" height={78} />
      <StyledGroupElementScroll>
        {cardsArray.map((_, index) => {
          return <SkeletonCardButtonSmallRounded key={index} />;
        })}
      </StyledGroupElementScroll>
    </Section>
  );
};
